import {authRedirectUrl, clearAuthenticatedCache} from "~/middleware/authenticated";

const hasUnauthorizedError = (graphQLErrors, networkError) => {
  if (networkError?.statusCode === 401 || networkError?.response?.status === 401) return true;

  return graphQLErrors?.some(error => {
    return error?.extensions?.code === 'UNAUTHENTICATED'
      || error?.message === 'Unauthorized'
      || error?.message?.includes('Unauthorized');
  });
}

export default ({graphQLErrors, networkError, operation, forward}, nuxtContext) => {
  console.log('Global error handler')
  console.log(graphQLErrors, networkError, operation, forward)
  if (!hasUnauthorizedError(graphQLErrors, networkError)) return;

  clearAuthenticatedCache(nuxtContext.store);
  window.location.replace(authRedirectUrl(nuxtContext.route));
}
